import React, { useEffect, useRef, useState } from "react";
import { UrlApi } from "../../services/apirest";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";
import { logEventos } from "../../services/services";

function DialogEditarVehiculo(props) {
  const { editar, datosRow, transportistas, onClose } = props;

  const [transportista, setTransportista] = useState(null);
  const [vehiculos, setVehiculos] = useState([]);
  const [vehiculo, setVehiculo] = useState(null);
  const [buscando, setBuscando] = useState(false);
  const [procesando, setProcesando] = useState(false);
  const [confirmacion, setConfirmacion] = useState("");
  const [error, setError] = useState("");
  const procesandoRef = useRef(false);

  useEffect(() => {
    setVehiculo(null);
    setVehiculos([]);
    setConfirmacion("");
    setError("");

    if (!transportista) return undefined;

    let vigente = true;
    setBuscando(true);

    fetch(
      UrlApi +
      "/vehiculos/vehict1/fechaytransportista/" +
      datosRow.fecha +
      "/" +
      transportista.id_transportista
    )
      .then((res) => res.json())
      .then((data) => {
        if (vigente) setVehiculos(Array.isArray(data) ? data : []);
      })
      .catch((err) => {
        console.error(err);
        if (vigente) setError("No se pudieron cargar los vehículos.");
      })
      .finally(() => {
        if (vigente) setBuscando(false);
      });

    return () => {
      vigente = false;
    };
  }, [transportista, datosRow.fecha]);

  const cerrar = () => {
    if (procesandoRef.current) return;
    if (onClose) onClose();
  };

  const guardarVehiculo = async (confirmar = false) => {
    if (!vehiculo || procesandoRef.current) return;

    procesandoRef.current = true;
    setProcesando(true);
    setError("");

    let cerrarAlTerminar = false;

    try {
      const res = await fetch(
        UrlApi +
        "/viajes_abastecimiento/" +
        datosRow.id_viaje +
        "/cambiar-vehiculo",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            vehiculo: vehiculo.id,
            confirmar_vehiculo: confirmar,
          }),
        }
      );

      const data = await res.json().catch(() => null);

      if (res.status === 409 && data?.codigo === "CONFIRMACION_VEHICULO") {
        setConfirmacion(data.mensaje);
        return;
      }

      if (!res.ok || !data?.ok) {
        setConfirmacion("");
        setError(data?.mensaje || "No se pudo cambiar el vehículo.");
        return;
      }

      logEventos(
        "Guardar edición del vehiculo",
        "Viajes",
        "Se cambió el vehículo del viaje " + datosRow.id_viaje,
        localStorage.getItem("user")
      );

      cerrarAlTerminar = true;
    } catch (err) {
      console.error(err);
      setError("No se pudo conectar con el servidor. Intentá nuevamente.");
    } finally {
      procesandoRef.current = false;
      setProcesando(false);
    }

    if (cerrarAlTerminar && onClose) onClose();
  };

  return (
    <Dialog open={editar} onClose={cerrar} fullWidth maxWidth="sm">
      <DialogTitle>Editar vehículo del viaje N° {datosRow.id_viaje}</DialogTitle>

      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0 }}>
          <Grid item xs={12}>
            <Autocomplete
              size="small"
              options={transportistas || []}
              value={transportista}
              autoHighlight
              noOptionsText="Transportista inexistente"
              isOptionEqualToValue={(opcion, valor) =>
                opcion.id_transportista === valor.id_transportista
              }
              getOptionLabel={(opcion) =>
                opcion.id_transportista + "-" + opcion.nombre
              }
              onChange={(event, valor) => setTransportista(valor)}
              renderInput={(params) => (
                <TextField {...params} required label="Transportista" />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <Autocomplete
              size="small"
              options={vehiculos}
              value={vehiculo}
              disabled={!transportista || buscando}
              autoHighlight
              noOptionsText="No hay vehículos disponibles"
              isOptionEqualToValue={(opcion, valor) => opcion.id === valor.id}
              getOptionLabel={(opcion) =>
                opcion.patente +
                (opcion.patentes_acoplados
                  ? " (Acoplados: " + opcion.patentes_acoplados + ")"
                  : "")
              }
              onChange={(event, valor) => {
                setVehiculo(valor);
                setConfirmacion("");
                setError("");
              }}
              renderOption={(optionProps, opcion) => (
                <Box component="li" {...optionProps} key={opcion.id}>
                  {opcion.patente}
                  {opcion.patentes_acoplados
                    ? " Acoplados: " + opcion.patentes_acoplados
                    : ""}
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  required
                  label={buscando ? "Buscando vehículos..." : "Vehículo"}
                />
              )}
            />
          </Grid>

          {confirmacion ? (
            <Grid item xs={12}>
              <Alert severity="warning">{confirmacion}</Alert>
            </Grid>
          ) : null}

          {error ? (
            <Grid item xs={12}>
              <Alert severity="error">{error}</Alert>
            </Grid>
          ) : null}
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={cerrar} disabled={procesando}>
          Volver
        </Button>
        <Button
          variant="contained"
          color={confirmacion ? "warning" : "success"}
          disabled={!vehiculo || procesando}
          onClick={() => guardarVehiculo(Boolean(confirmacion))}
        >
          {procesando
            ? "Guardando..."
            : confirmacion
              ? "Continuar de todos modos"
              : "Guardar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogEditarVehiculo;